<div #contenedor class="chat-messages flex flex-column gap-2 p-3" (scroll)="alDesplazar()">
  @if (grupos().length === 0) {
    <p class="m-auto text-sm text-color-secondary">Todav&iacute;a no hay mensajes en este chat.</p>
  }

  @for (grupo of grupos(); track grupo.fecha) {
    <div class="flex justify-content-center my-2">
      <span class="chat-messages__fecha px-2 py-1 text-xs border-round">{{ grupo.label }}</span>
    </div>

    @for (mensaje of grupo.mensajes; track mensaje.id) {
      @if (mensaje.tipo === 'sistema') {
        <div class="flex justify-content-center my-2">
          <span class="chat-messages__fecha px-2 py-1 text-xs text-center border-round">
            {{ mensaje.nota }}
            @if (mensaje.hora) {
              <span class="chat-messages__hora ml-2">{{ mensaje.hora }}</span>
            }
          </span>
        </div>
      } @else {
        <div class="flex" [class.justify-content-end]="mensaje.tipo === tipoPropio()">
          <div
            class="chat-messages__burbuja px-3 py-2 border-round"
            [class.chat-messages__burbuja--propia]="mensaje.tipo === tipoPropio()"
          >
            <span class="text-sm">{{ mensaje.nota }}</span>
            <span class="chat-messages__hora ml-2 text-xs">{{ mensaje.hora }}</span>
          </div>
        </div>
      }
    }
  }
</div>
